import { render, staticRenderFns } from "./MiningDetail.vue?vue&type=template&id=64551f7c&"
import script from "./MiningDetail.vue?vue&type=script&lang=js&"
export * from "./MiningDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports